import DocumentSheduleEditor from './DocumentSheduleEditor'

export default DocumentSheduleEditor;